<template>
  <div id="app-header">
    <img id="dj-logo" :src="showStyle===0? require(`@/assets/images/djxinxilogo.png`):require(`@/assets/images/djxinxilogo1.png`)" @click="logoClick()"/>
    <router-link :to="(constants.navData[0]).path" active-class="nav-active" :class="showStyle===0?'nav-common-style0':'nav-common-style1'" class="nav-common" style="left:517px;width: 44px">
      {{ (constants.navData[0]).pageName }}
    </router-link>

    <el-popover
      placement="bottom-start"
      effect="dark"
      :width="220"
      trigger="hover"
      :show-arrow="false">

      <template #reference>
        <router-link :to="(constants.navData[1]).path" active-class="nav-active" :class="showStyle===0?'nav-common-style0':'nav-common-style1'" class="nav-common" style="left:727px;width: 86px">
          {{ (constants.navData[1]).pageName }}
        </router-link>
      </template>

      <router-link :to="(navSub).path" active-class="nav-active" v-for="navSub in constants.navSubData" class="nav-sub-common">
        <div>
          {{ (navSub).pageName }}
        </div>
      </router-link>

    </el-popover>

    <router-link :to="(constants.navData[2]).path" active-class="nav-active" :class="showStyle===0?'nav-common-style0':'nav-common-style1'" class="nav-common" style="left:976px;width: 86px">
      {{ (constants.navData[2]).pageName }}
    </router-link>

  </div>
</template>

<script>
import { computed } from "vue";
import { useRouter } from "vue-router";
import constants from "@/api/constants";


export default {
  name: "HeaderView",
  props:{
    showStyle:{
      type:Number,
      default:0,
    }
  },
  setup() {
    const router = useRouter();
    const nav = computed(() => {
      return router.options.routes;
    });
    function logoClick(){
      router.push({ path: constants.navData[0].path });
    }
    return {
      nav,
      constants,
      logoClick,
    };
  }
};

</script>

<style scoped>
#app-header {
  width: 100%;
  height: 98px;
  position: relative;
}

#dj-logo {
  width: 180px;
  height: 55px;
  margin-left: 179px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.nav-common{
  font-size: 19px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  text-align: center;
}

.nav-common-style0 {
  color: white;
}

.nav-common-style1 {
  color: black;
}

.nav-sub-common {
  color: white;
  font-size: 16px;
  line-height: 40px;
}

.nav-active {
  color: #266db7;
}

</style>
